










import { Component, Mixins } from "vue-property-decorator";
import { DialogSelectableMixin } from "./mixins";

@Component
export default class DialogSelector extends Mixins(DialogSelectableMixin) {
}
